"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var changeFontSize_1 = require("./format/changeFontSize");
exports.changeFontSize = changeFontSize_1.default;
exports.FONT_SIZES = changeFontSize_1.FONT_SIZES;
var clearBlockFormat_1 = require("./format/clearBlockFormat");
exports.clearBlockFormat = clearBlockFormat_1.default;
exports.TAGS_TO_UNWRAP = clearBlockFormat_1.TAGS_TO_UNWRAP;
exports.TAGS_TO_STOP_UNWRAP = clearBlockFormat_1.TAGS_TO_STOP_UNWRAP;
exports.ATTRIBUTES_TO_PRESERVE = clearBlockFormat_1.ATTRIBUTES_TO_PRESERVE;
var clearFormat_1 = require("./format/clearFormat");
exports.clearFormat = clearFormat_1.default;
var createLink_1 = require("./format/createLink");
exports.createLink = createLink_1.default;
var getFormatState_1 = require("./format/getFormatState");
exports.getFormatState = getFormatState_1.default;
exports.getElementBasedFormatState = getFormatState_1.getElementBasedFormatState;
exports.getStyleBasedFormatState = getFormatState_1.getStyleBasedFormatState;
var insertImage_1 = require("./format/insertImage");
exports.insertImage = insertImage_1.default;
var insertTable_1 = require("./table/insertTable");
exports.insertTable = insertTable_1.default;
var editTable_1 = require("./table/editTable");
exports.editTable = editTable_1.default;
var formatTable_1 = require("./table/formatTable");
exports.formatTable = formatTable_1.default;
var removeLink_1 = require("./format/removeLink");
exports.removeLink = removeLink_1.default;
var replaceWithNode_1 = require("./format/replaceWithNode");
exports.replaceWithNode = replaceWithNode_1.default;
var rotateElement_1 = require("./format/rotateElement");
exports.rotateElement = rotateElement_1.default;
var setAlignment_1 = require("./format/setAlignment");
exports.setAlignment = setAlignment_1.default;
var setBackgroundColor_1 = require("./format/setBackgroundColor");
exports.setBackgroundColor = setBackgroundColor_1.default;
var setTextColor_1 = require("./format/setTextColor");
exports.setTextColor = setTextColor_1.default;
var setDirection_1 = require("./format/setDirection");
exports.setDirection = setDirection_1.default;
var setFontName_1 = require("./format/setFontName");
exports.setFontName = setFontName_1.default;
var setFontSize_1 = require("./format/setFontSize");
exports.setFontSize = setFontSize_1.default;
var setImageAltText_1 = require("./format/setImageAltText");
exports.setImageAltText = setImageAltText_1.default;
var setIndentation_1 = require("./format/setIndentation");
exports.setIndentation = setIndentation_1.default;
var toggleBold_1 = require("./format/toggleBold");
exports.toggleBold = toggleBold_1.default;
var toggleBullet_1 = require("./format/toggleBullet");
exports.toggleBullet = toggleBullet_1.default;
var toggleItalic_1 = require("./format/toggleItalic");
exports.toggleItalic = toggleItalic_1.default;
var toggleNumbering_1 = require("./format/toggleNumbering");
exports.toggleNumbering = toggleNumbering_1.default;
var toggleBlockQuote_1 = require("./format/toggleBlockQuote");
exports.toggleBlockQuote = toggleBlockQuote_1.default;
var toggleCodeBlock_1 = require("./format/toggleCodeBlock");
exports.toggleCodeBlock = toggleCodeBlock_1.default;
var toggleStrikethrough_1 = require("./format/toggleStrikethrough");
exports.toggleStrikethrough = toggleStrikethrough_1.default;
var toggleSubscript_1 = require("./format/toggleSubscript");
exports.toggleSubscript = toggleSubscript_1.default;
var toggleSuperscript_1 = require("./format/toggleSuperscript");
exports.toggleSuperscript = toggleSuperscript_1.default;
var toggleUnderline_1 = require("./format/toggleUnderline");
exports.toggleUnderline = toggleUnderline_1.default;
var toggleHeader_1 = require("./format/toggleHeader");
exports.toggleHeader = toggleHeader_1.default;
// @deprecated the function getPendableFormatState will still be available from
// roosterjs-editor-dom package, keep export it here just for compatibility
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
exports.getPendableFormatState = roosterjs_editor_dom_1.getPendableFormatState;
//# sourceMappingURL=index.js.map